import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import useFanPublicationStore from "%/stores/fan-publication-store";

export const useMyPublicationDigitalProductFeedStore =
  defineSmartFeedPiniaStore("my-publication-digital-product-feed-store", {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
    }),
    getters: {
      // Lazy read: a state snapshot froze publicationId at 0 pre-seed.
      feedUrl() {
        return `/publication-digital-products/publication/${useFanPublicationStore().publicationId}/smart-feed`;
      },
    },
  });
